// @flow
import { handleResponseOld, handleResponseWithNon200Errors, makeGet, makePost } from './helpers';
import take from 'lodash/take';

type FetchFollowerCountParams = {
    deployment: string,
    sellerIds: number[],
};

type FetchSellersParams = {
    deployment: string,
};

type FetchSellersByIdsParams = {
    authToken: string,
    deployment: string,
    sellerIds: number[],
};

type PostFollowParams = {
    authToken: string,
    deployment: string,
    sellerId: number,
};

type PostMessageParams = {
    authToken: string,
    deployment: string,
    messageDetails: any,
};

type PostUnfollowParams = {
    authToken: string,
    deployment: string,
    sellerId: number,
};

export default {
    fetchFollowerCount: ({ deployment, sellerIds }: FetchFollowerCountParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ deployment, path: '<ITEM-API>follower-count/' });
            request.send({ sellerIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSellers: ({ deployment }: FetchSellersParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ deployment, path: '<ITEM-API>spa/small/sellers' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSellersByIds: ({ authToken, deployment, sellerIds }: FetchSellersByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/sellers' });
            request.send({ ids: sellerIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postFollow: ({ authToken, deployment, sellerId }: PostFollowParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'followhouse',
                authToken,
                deployment,
                path: '<PERSONALIZATION-API>',
            });
            request.send({ houseId: sellerId });
            request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
        }),
    postMessage: ({ authToken, deployment, messageDetails }: PostMessageParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                authToken,
                deployment,
                path: '<MAINHOST-API>api/s_msg',
                queryParams: { client_version: '4.3' },
            });

            if (!messageDetails) reject(new Error('no message details sent'));

            const { catalogId, files, itemId, message, sellerId, subject } = messageDetails;

            request
                .field('cat_id', catalogId || 0)
                .field('cc_sender', false)
                .field('house_id', sellerId)
                .field('lot_id', itemId || 0)
                .field('message_text', message)
                .field('subject', subject);

            take(files || [], 5).forEach((f, idx) => {
                const fieldName = idx === 0 ? 'attach' : `attach${idx}`;
                request.attach(fieldName, f);
            });

            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postUnfollow: ({ authToken, deployment, sellerId }: PostUnfollowParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: 'unfollowhouse',
                authToken,
                deployment,
                path: '<PERSONALIZATION-API>',
            });
            request.send({ houseId: sellerId });
            request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
        }),
};
